import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import { draggableResource, XResource } from '../../commonComponents';
import { EDIE_BLOCK_TYPE } from '@cimpress-technology/edie-processors';
import Icon from './icon_repeater.svg';

class XLoopResource extends Component {
  render () {
    return draggableResource(this.props, <div>
      <XResource resourceName={'Repeater'} resourceIcon={Icon} />
    </div>);
  }
}

const source = {
  beginDrag (_props) {
    return {
      resourceType: EDIE_BLOCK_TYPE.LOOP
    };
  }
};

function collect (connect, monitor) {
  return {
    connectDragPreview: connect.dragPreview(),
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

export default DragSource(EDIE_BLOCK_TYPE.LOOP, source, collect)(XLoopResource);
